/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createEduvanceAiUsers = /* GraphQL */ `
  mutation CreateEduvanceAiUsers($input: CreateEduvanceAiUsersInput!) {
    createEduvanceAiUsers(input: $input) {
      User
      expiry
      type
    }
  }
`;
export const deleteEduvanceAiUsers = /* GraphQL */ `
  mutation DeleteEduvanceAiUsers($input: DeleteEduvanceAiUsersInput!) {
    deleteEduvanceAiUsers(input: $input) {
      User
      expiry
      type
    }
  }
`;
export const updateEduvanceAiUsers = /* GraphQL */ `
  mutation UpdateEduvanceAiUsers($input: UpdateEduvanceAiUsersInput!) {
    updateEduvanceAiUsers(input: $input) {
      User
      expiry
      type
    }
  }
`;
export const createEduvanceAITool = /* GraphQL */ `
  mutation CreateEduvanceAITool($input: CreateEduvanceAIToolInput!) {
    createEduvanceAITool(input: $input) {
      extraField1
      projectname
      projectData
      projectType
      user
    }
  }
`;
export const updateEduvanceAITool = /* GraphQL */ `
  mutation UpdateEduvanceAITool($input: UpdateEduvanceAIToolInput!) {
    updateEduvanceAITool(input: $input) {
      extraField1
      projectname
      projectData
      projectType
      user
    }
  }
`;
export const deleteEduvanceAITool = /* GraphQL */ `
  mutation DeleteEduvanceAITool($input: DeleteEduvanceAIToolInput!) {
    deleteEduvanceAITool(input: $input) {
      extraField1
      projectname
      projectData
      projectType
      user
    }
  }
`;
